import { API_TEMPLATE } from 'src/libs/constant'
import { get, patch, post, put } from 'src/libs/query'
import { formatUrl } from 'src/libs/url'
import { URL_API } from 'src/libs/constant/class-demo/classDemo'
import { SESSION_URL_API } from 'src/libs/constant/session'

const classApi = {
  addStudentRegular (payload) {
    return post(`${API_TEMPLATE.CLASS_ADD_STUDENT_REGULAR}`, payload)
  },
  arrangeClassManual (payload) {
    return post(`${API_TEMPLATE.CLASS_REGULAR_TICKET_CREATE}`, payload)
  },
  arrangeDetail (id) {
    const path = formatUrl(API_TEMPLATE.CLASS_ARRANGE_DETAIL, [
      { key: 'id', value: id }
    ])
    return get(path)
  },
  assignCoor ({ userId, arrangeId }) {
    return post(`${API_TEMPLATE.CLASS_ARRANGE_CLASS_ASSSIGN}?taskId=${arrangeId}&userId=${userId}`)
  },
  assignCoorMultiple (payload) {
    return post(API_TEMPLATE.CLASS_ASSIGN_COOR_MULTIPLE, payload)
  },
  assignMultipleByFilter (payload, isDivideEvenly) {
    return post(
      `${API_TEMPLATE.CLASS_ASSIGN_MULTIPLE_BY_FILTER}?isDivideEvenly=${isDivideEvenly}`,
      payload
    )
  },
  assignMultipleClassRegular (payload) {
    return post(`${API_TEMPLATE.CLASS_ASSIGN_MULTIPLE_CLASS_REGULAR}`, payload)
  },
  assignMultipleClassMonitor (payload) {
    return post(
      `${API_TEMPLATE.CLASS_ASSIGN_MULTIPLE_CLASS_MONITOR}`,
      payload
    )
  },
  addStudentNoteClassDemo (payload) {
    return post(API_TEMPLATE.CLASS_DEMO_ADD_NOTE_STUDENT, payload)
  },
  getStudentClassDemoFilter (payload) {
    return post(API_TEMPLATE.CLASS_DEMO_STUDENT_FILTER, payload)
  },
  cancel (classId) {
    return post(`${API_TEMPLATE.CLASS_CANCEL}?id=${classId}`)
  },
  cancelStudent ({ classId, studentId, reason, dateOff }) {
    return post(
      `${API_TEMPLATE.CLASS_CANCEL_STUDENT}`, { classId, studentId, reason, dateOff }
    )
  },
  changeCallStatus ({ callStatus, arrangeId }) {
    return post(
      `${API_TEMPLATE.CLASS_CHANGE_CALL_STATUS}?id=${arrangeId}&status=${callStatus}`
    )
  },
  changeCallStatusRescheduleDemo ({ callStatus, id }) {
    return post(
      `${API_TEMPLATE.CLASS_CHANGE_CALL_STATUS_RESCHEDULE_DEMO}`, { id, callStatus }
    )
  },
  changeLog (classId) {
    return get(`${API_TEMPLATE.CLASS_LOG_CHANGE}?classId=${classId}`)
  },
  changeClass ({ classId, studentId, reason, dateOff, conditionRequest, changeClassReason }) {
    return post(`${API_TEMPLATE.CLASS_CHANGE}`, {
      classId,
      studentId,
      reason,
      dateOff,
      conditionRequest,
      changeClassReason
    })
  },
  changeStudentOfOrder ({ userId, orderDataId }) {
    return post(
      `${API_TEMPLATE.CLASS_CHANGE_ORDER_STUDENT}?userId=${userId}&orderDataId=${orderDataId}`
    )
  },
  createRegularSession (payload) {
    return post(API_TEMPLATE.CLASS_CREATE_REGULAR_SESSION, payload)
  },
  currenOder (studentId) {
    return get(
      `${API_TEMPLATE.CLASS_CURRENT_STUDENT_ORDER}?studentId=${studentId}`
    )
  },
  detail (id) {
    return get(`${API_TEMPLATE.CLASS_DETAIL}?id=${id}`)
  },
  detailWithChild (id) {
    return get(`${API_TEMPLATE.CLASS_DETAIL_WITH_CHILDREN}?id=${id}`)
  },
  detailSessionRegular (id) {
    return get(`${API_TEMPLATE.SESSION_ITEM}?id=${id}`)
  },
  detailClassRegular (id) {
    return get(`${API_TEMPLATE.CLASS_REGULAR_DETAIL}?id=${id}`)
  },
  detailClassDemo (id) {
    return get(`${API_TEMPLATE.CLASS_DEMO_DETAIL}?id=${id}`)
  },
  getClassRegularDetailById (id) {
    return get(`${API_TEMPLATE.CLASS_REGULAR_DETAIL}?id=${id}`)
  },
  detailWithStudent (id) {
    return get(
      `${API_TEMPLATE.CLASS_DEMO_GET_DETAIL_WITH_STUDENTS}?id=${id}`
    )
  },
  detailRegularWithChildren (id) {
    return get(
      `${API_TEMPLATE.CLASS_REGULAR_GET_DETAIL_WITH_STUDENTS}?id=${id}`
    )
  },
  detailOrder (id) {
    return get(`/api/calendar/crm-package/id?id=${id}`)
  },
  detailCrmOrder (id) {
    return get(`${API_TEMPLATE.CRM_ORDER_DETAIL}?id=${id}`)
  },
  divideData ({ payload }) {
    return post(API_TEMPLATE.CLASS_DIVIDE_DATA, payload)
  },
  divideEvenlyData ({ payload }) {
    return post(API_TEMPLATE.CLASS_DIVIDE_EVENLY_BY_FILTER, payload)
  },
  exportArrangeClass ({ payload, sheetId, sheetName }) {
    return post(
      `${API_TEMPLATE.CLASS_EXPORT_ARRANGE_CLASS}?sheetId=${sheetId}&sheetName=${sheetName}`,
      payload
    )
  },
  getListArrangeClassRegularById (id) {
    return get(`${API_TEMPLATE.CLASS_REGULAR_ARRANGE_CLASS_DETAIL_BY_ID}?id=${id}`)
  },
  getArrangeClassRegularById (id) {
    return get(`${API_TEMPLATE.CLASS_REGULAR_ARRANGE_CLASS_BY_ID}?id=${id}`)
  },
  exportRegularClass ({ payload, sheetId, sheetName1, sheetName2 }) {
    return post(
      `${API_TEMPLATE.CLASS_EXPORT_REGULAR_CLASS}?sheetId=${sheetId}&sheetName1=${sheetName1}&sheetName2=${sheetName2}`,
      payload
    )
  },
  findLastActiveOrderByUserId (userId) {
    return get(
      `${API_TEMPLATE.CLASS_LIST_ORDER_BY_USERID_AND_STATUS}?userId=${userId}`
    )
  },
  filterClassDemoSlot (payload, queryString) {
    return post(`${API_TEMPLATE.CLASS_DEMO_FILTER}?isFilterSlotDemo=true`, {
      ...payload,
      sortOrders: queryString?.sortOrders || []
    })
  },
  filterClassDemo (payload, queryString) {
    return post(`${API_TEMPLATE.CLASS_DEMO_FILTER}`, { ...payload, sortOrders: queryString?.sortOrders || [] })
  },
  detailClassDemoById (id) {
    return get(`${API_TEMPLATE.CLASS_DEMO_DETAIL}?id=${id}`)
  },
  getExtendData (userId) {
    return get(`${API_TEMPLATE.CLASS_EXTEND_STUDENT_DATA}?userId=${userId}`)
  },
  getStudentAccount (classId) {
    // TODO: Sử dụng tạm API lấy list student trong class
    return post(`${API_TEMPLATE.CLASS_STUDENT_ACCOUNT}?classId=${classId}`)
  },
  getStudentProfile (studentId) {
    return get(`${API_TEMPLATE.CLASS_STUDENT_PROFILE}?studentId=${studentId}`)
  },
  getStudentTransactions ({ studentId, page, size }) {
    return get(
      `${API_TEMPLATE.CLASS_STUDENT_TRANSACTIONS}?studentId=${studentId}&page=${
        page || 0
      }&size=${size || 999}`
    )
  },
  getListStudentsInClass (classId) {
    return post(`${API_TEMPLATE.CLASS_REGULAR_LIST_STUDENTS}?classId=${classId}`)
  },
  getTeacherClassify (payload) {
    return post(`${API_TEMPLATE.TEACHER_CLASSIFY_FILTER}`, payload)
  },
  getListStudyProgram ({ id }) {
    return get(`${API_TEMPLATE.CLASS_STUDENT_STUDY_PROGRAM}?id=${id}`)
  },
  getStudyProgramWithChildren (id) {
    return get(`${API_TEMPLATE.CLASS_STUDENT_STUDY_PROGRAM_WITH_CHILDREN}?id=${id}`)
  },
  getDemoPlan ({ dateFrom, dateTo, scheduleType }) {
    return get(
      `${API_TEMPLATE.ASSIGN_GET_DEMO_PLAN}?dateFrom=${dateFrom}&dateTo=${dateTo}&scheduleType=${scheduleType}`
    )
  },
  getClassDemoDetailById (classId) {
    return get(`${API_TEMPLATE.CLASS_DEMO_DETAIL}?id=${classId}`)
  },
  getStartTimeStudentClass ({ classId, studentId }) {
    return get(`${API_TEMPLATE.CLASS_GET_STARTTIME_STUDENT}?classRegularId=${classId}&studentId=${studentId}`)
  },
  list ({ criteria, page, size }) {
    const path = API_TEMPLATE.CLASS_FILTER
    return post(path, { criteria, page, size })
  },
  listPackage () {
    return get(API_TEMPLATE.CLASS_LIST_PACKAGE)
  },
  extend (payload) {
    return post(API_TEMPLATE.CLASS_EXTEND, payload)
  },
  listOrder (payload) {
    return post(API_TEMPLATE.CLASS_PENDING_STUDENT_FILTER, payload)
  },
  listTicketArangeClassRegular (payload, queryString) {
    return post(API_TEMPLATE.CLASS_REGULAR_ARRANGE_CLASS_FILTER, { ...payload, ...queryString })
  },
  addNotesArangeClassRegular (payload) {
    return post(API_TEMPLATE.CLASS_REGULAR_ARRANGE_CLASS_ADD_NOTES, payload)
  },
  updateStudentInfo (payload) {
    return patch(API_TEMPLATE.CLASS_UPDATE_PENDING_STUDENT, payload) // post
  },
  updateClass (payload) {
    return put(API_TEMPLATE.CLASS_UPDATE_DETAIL, payload)
  },
  updateClassSession (payload) {
    return post(API_TEMPLATE.CLASS_UPDATE_SESSION, payload)
  },
  updateClassStudent ({ classId, studentId, startTime }) {
    return put(`${API_TEMPLATE.CLASS_UPDATE_CLASS_STUDENT_DETAIL}?id=${classId}&studentId=${studentId}&startTime=${startTime}`)
  },
  updateRemainSession ({ orderId, remainSession }) {
    return post(
      `${API_TEMPLATE.CLASS_UPDATE_REMAIN_SESSION}?orderId=${orderId}&remainSession=${remainSession}`
    )
  },
  updateAccountCredit (payload) {
    return post(
      `${API_TEMPLATE.CLASS_UPDATE_ACCOUNT_CREDIT}`, payload
    )
  },
  updateMainSessionCredit (payload) {
    return post(`${API_TEMPLATE.CLASS_UPDATE_MAIN_SESSION_CREDIT}`, payload)
  },
  updateBusySessionCredit (payload) {
    return post(`${API_TEMPLATE.CLASS_UPDATE_BUSY_SESSION_CREDIT}`, payload)
  },
  updateDemoPlan (payload) {
    return post(`${API_TEMPLATE.ASSIGN_UPDATE_DEMO_PLAN}`, payload)
  },
  addClassRegNote (payload) {
    return post(`${API_TEMPLATE.CLASS_ADD_NOTE}`, payload)
  },
  addClassRegStudentNote (payload) {
    return post(`${API_TEMPLATE.CLASS_ADD_STUDENT_NOTE}`, payload)
  },
  getArrangeMessage (studentId) {
    return get(`${API_TEMPLATE.CLASS_ARRANGE_MESSAGE}?studentId=${studentId}`)
  },
  cancelClass ({ classId, conditionRequest }) {
    return post(`${API_TEMPLATE.CLASS_CANCEL}`, { classId, conditionRequest })
  },
  exportWaitingConfirmClass ({ payload, sheetId, sheetName }) {
    return post(
      `${API_TEMPLATE.EXPORT_WAITING_CONFIRM_CLASS}?sheetId=${sheetId}&sheetName=${sheetName}`,
      payload
    )
  },
  updateStatusWaitingConfirm (payload) {
    return post(API_TEMPLATE.UPDATE_STATUS_WAITING_CONFIRM, payload)
  },
  updateStatusWaitingConfirmTeacherSuggest (payload) {
    return post(API_TEMPLATE.UPDATE_STATUS_WAITING_CONFIRM_TEACHER_SUGGEST, payload)
  },
  updateStatusWaitingMultiple (payload) {
    return post(API_TEMPLATE.UPDATE_STATUS_WAITING_MULTIPLE, payload)
  },
  checkTeacherStatusWaitingConfirm (classId, teacherId) {
    return get(`${API_TEMPLATE.WAITING_CONFIRM_CHECK_TEACHER_STATUS}?classId=${classId}&teacherId=${teacherId}`)
  },
  saveNoteChangeTeacher (payload) {
    return post(API_TEMPLATE.SAVE_NOTE_CHANGE_TEACHER, payload)
  },
  getClassRequestDetail ({ taskArrangeClassDetailId, studentId, studyProgramId, studentArrangeRequestType }) {
    return get(
      `${API_TEMPLATE.CLASS_REQUEST_DETAIL}?taskArrangeClassDetailId=${taskArrangeClassDetailId}&studentId=${studentId}&studyProgramId=${studyProgramId}&studentArrangeRequestType=${studentArrangeRequestType}`
    )
  },
  cancelClassDemo (classDemoId) {
    return post(API_TEMPLATE.CLASS_DEMO_CANCEL.replace('{id}', classDemoId))
  },
  startTimeOfClassRegular (payload) {
    return post(API_TEMPLATE.CLASS_GET_STARTTIME_STUDENT, payload)
  },
  getLogChangeSchedule (payload) {
    return post(API_TEMPLATE.CLASS_GET_LOG_SCHEDULE, payload)
  },

  //lớp đào tạo gia sư
  classTraining (payload) {
    return post(API_TEMPLATE.CLASS_TRAINING, payload)
  },
  classTrainingFinished (id) {
    const path = formatUrl(API_TEMPLATE.CLASS_TRAINING_FINISHED, [{ key: 'id', value: id }])
    return post(path)
  },
  classTrainingRemove (payload) {
    return post(API_TEMPLATE.CLASS_TRAINING_REMOVE_MULTIPLE, payload)
  },
  classTrainingAdd (payload) {
    return post(API_TEMPLATE.CLASS_TRAINING_ADD_MULTIPLE, payload)
  },
  classTrainingTransfer (payload) {
    return post(API_TEMPLATE.CLASS_TRAINING_TRANSFER_MULTIPLE, payload)
  },
  classTrainingImport ({ sheetId, sheetName, classTrainingId }) {
    return post(`${API_TEMPLATE.CLASS_TRAINING_IMPORT}?sheetId=${sheetId}&sheetName=${sheetName}&classTrainingId=${classTrainingId}`)
  },
  classTrainingExport ({ sheetId, sheetName, payload }) {
    return post(`${API_TEMPLATE.CLASS_TRAINING_EXPORT}?sheetId=${sheetId}&sheetName=${sheetName}`, payload)
  },
  classTrainingFilter (payload, sortPayload = {}) {
    return post(API_TEMPLATE.CLASS_TRAINING_FILTER, { ...payload, ...sortPayload })
  },
  classTrainingDetail (id) {
    return get(`${API_TEMPLATE.CLASS_TRAINING_DETAIL}/${id}`)
  },
  classTrainingDetailStudent (id) {
    return get(`${API_TEMPLATE.CLASS_TRAINING_DETAIL_STUDENT}/${id}/student`)
  },
  classTrainingCreateSession (payload) {
    return post(API_TEMPLATE.CLASS_TRAINING_CREATE_SESSION, payload)
  },
  classTrainingCourseDetail (id) {
    const path = formatUrl(API_TEMPLATE.CLASS_TRAINING_COURSE_DETAIL, [{ key: 'id', value: id }])
    return get(path)
  },
  sessionTrainingDetail (id) {
    const path = formatUrl(API_TEMPLATE.CLASS_TRAINING_SESSION_DETAIL, [{ key: 'id', value: id }])
    return post(path)
  },
  getClassRegularDetailByIds (ids) {
    return post(API_TEMPLATE.CLASS_REGULAR_BY_IDS, { ids })
  },

  //class demo
  getTeacherByIdSession ({ id, isCheckRequirement = true }) {
    const path = formatUrl(API_TEMPLATE.GET_TEACHER_BY_ID_SESSION, [{ key: 'id', value: id }])
    return get(`${path}?isCheckRequirement=${isCheckRequirement}&sortField=teacherLevelPosition&sortDirection=asc`)
  },
  classDemoVipSubmitTest (payload) {
    const path = API_TEMPLATE.CLASS_DEMO_VIP_TEST
    return put(path, payload)
  },
  classDemoVipAddNote (payload) {
    const path = API_TEMPLATE.CLASS_DEMO_VIP_ADD_NOTE
    return post(path, payload)
  },

  getClassScheduleSlotLimit (params) {
    const path = API_TEMPLATE.CLASS_SCHEDULE_SLOT_LIMIT
    return get(path, params)
  },
  postClassScheduleSlotLimit (payload) {
    const path = API_TEMPLATE.CLASS_SCHEDULE_SLOT_LIMIT
    return post(path, payload)
  },
  findAvailableForArrangeClass (params) {
    const path = API_TEMPLATE.FIND_AVAILABLE_FOR_ARRANGE_CLASS
    return get(path, params)
  },

  enterClassIn ({ sessionId, sessionType }) {
    const path = `${formatUrl(API_TEMPLATE.GET_LINK_LOGIN_CLASS_IN_BY_SESSION_ID_AUTH, [
      { key: 'sessionId', value: sessionId },
      { key: 'sessionType', value: sessionType },
    ])}`
    return get(path)
  },

  getCalenderTimetable (payload) {
    const path = API_TEMPLATE.GET_CALENDAR_TIME_TABLE
    return post(path, payload)
  },
  assignCoordinator ({ id, coordinatorId }) {
    let path = `${URL_API.ASSIGN_COORDINATOR}?id=${id}`
    if (coordinatorId) {
      path += `&coordinatorId=${coordinatorId}`
    }
    return patch(path)
  }
}

export default classApi
